import _ from "underscore";

import { isBigBimViewerPerformanceOn } from "./big_bim_viewer_performance";

/** The Set returned when there are no ids. Never mutated. */
export const EMPTY_DB_IDS = new Set<number>();

// One loop straight into the Set: this runs over every element of the floor each time its elements change.
function getSetOfDbIds<Element extends { globalId: string }>(elements: Element[] | { [globalId: string]: Element }): Set<number> {
  if (!isBigBimViewerPerformanceOn()) {
    if ((Array.isArray(elements) && elements.length) || Object.keys(elements).length) {
      return new Set(_(elements).pluck("globalId").map(getDbId));
    } else {
      return EMPTY_DB_IDS;
    }
  }
  const dbIds = new Set<number>();
  if (Array.isArray(elements)) {
    for (let i = 0; i < elements.length; i++) {
      dbIds.add(getDbId(elements[i]?.globalId));
    }
  } else if (elements) {
    for (const key in elements) {
      dbIds.add(getDbId(elements[key]?.globalId));
    }
  }
  return dbIds.size ? dbIds : EMPTY_DB_IDS;
}

export function getDbId(globalId: string) {
  if (globalId) {
    return parseInt(globalId.substr("Obj".length), 10);
  } else {
    return null;
  }
}

export default getSetOfDbIds;
